import script from "./DeadlineTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineTable.vue?vue&type=style&index=0&id=7746ae34&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7746ae34"]])

export default __exports__